module.exports = __webpack_public_path__ + "expedia-src-icon.png?7b4e4fe1a70c627fe015e2f6e59a59b2";